
const SET_MENU_SELECIONADO = (state, payload) => {
  state.menuSelecionado = payload
}

export {
  SET_MENU_SELECIONADO
}